(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!window.__ckDrawerUpgradeBound) {
    window.__ckDrawerUpgradeBound = true;
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-ck-drawer-upgrade], [data-ck-drawer-add-bump]');
      if (!button) return;
      const status = button.closest('.ck-drawer__bump')?.querySelector('[data-ck-drawer-status]');
      button.disabled = true;
      const isUpgrade = button.matches('[data-ck-drawer-upgrade]');
      if (status) status.textContent = isUpgrade ? 'Upgrading your chai pack…' : 'Adding gift-ready details…';
      try {
        const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.targetId), quantity: 1 }] })
        });
        if (!addResponse.ok) throw new Error(isUpgrade ? 'We could not add the larger pack. Your cart has not changed.' : 'We could not add the gift-ready option. Your cart has not changed.');
        if (isUpgrade) {
          const removeResponse = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: button.dataset.currentKey, quantity: 0 })
          });
          if (!removeResponse.ok) throw new Error('The larger pack was added. Please remove the smaller pack before checkout.');
        }
        const [drawerResponse, cartResponse] = await Promise.all([
          fetch(`${window.Shopify.routes.root}?sections=cart-drawer-section`), fetch(`${window.Shopify.routes.root}cart.js`)
        ]);
        const drawerSections = await drawerResponse.json();
        const currentDrawer = document.querySelector('#shopify-section-cart-drawer-section');
        if (currentDrawer && drawerSections['cart-drawer-section']) currentDrawer.outerHTML = drawerSections['cart-drawer-section'];
        const cartJson = await cartResponse.json();
        for (const count of document.querySelectorAll('.cart-bubble__text-count')) count.textContent = cartJson.item_count;
        document.querySelector('#cart-drawer')?.open();
      } catch (error) {
        if (status) status.textContent = error.message;
        button.disabled = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
